import getBoardProjects from './getBoardProjects';
import type { TimeStreamProject } from 'owa-timestream-types';

/**
 * Gets all projects that should be displayed in Calendar Board view sorted
 * by keeping boards with an app name at the top.
 * @returns projects that include the calendar app name or have no app name.
 */
export default function getSortedBoardProjects(): TimeStreamProject[] {
    return getBoardProjects().sort((a, b) => b.appName.localeCompare(a.appName));
}
